import {formatPrice} from '@/lib/use-price';
import {Button} from '@kidslabs/mario-ui-nextjs-react-core';
import cn from 'classnames';

interface IProductComboSummary {
    totalPrice: number;
    totalBasePrice: number;
    totalSavings: string;
    onSubmit: () => void;
    isLoading?: boolean;
}

const ProductComboSummary = ({
    totalPrice,
    totalBasePrice,
    totalSavings,
    onSubmit,
    isLoading = false,
}: IProductComboSummary) => {
    const isEqual = totalPrice === totalBasePrice;
    return (
        <div className="relative col-span-12 bg-white pl-5 after:left-[-6px] after:top-0 after:h-full after:w-px after:bg-KPZ_divider lg:col-span-4 lg:after:absolute xl:col-span-3">
            <div className="flex h-full w-full flex-col items-center justify-center gap-3">
                <div className="flex w-full flex-col items-center justify-center rounded-[1.25rem] bg-KPZ_Gray-06 px-5 py-3">
                    <span className="mb-4 text-base font-bold text-KPZ_text_1st">Tổng giá combo</span>
                    <p className="flex w-full items-end justify-between">
                        {isEqual ? (
                            <span></span>
                        ) : (
                            <span className="text-xs text-KPZ_text_1st line-through">
                                {formatPrice({amount: totalBasePrice, currencyCode: 'VND', locale: 'vi'})}
                            </span>
                        )}

                        <span className="text-[22px] font-extrabold leading-[25px] text-KPZ_Cam">
                            {formatPrice({amount: totalPrice, currencyCode: 'VND', locale: 'vi'})}
                        </span>
                    </p>
                    <p className="flex w-full items-end justify-between">
                        <span className="text-xs text-KPZ_text_1st">Tiết kiệm:</span>
                        <span className="text-sm font-bold text-KPZ_Cam">{totalSavings}</span>
                    </p>
                </div>

                <Button
                    onClick={onSubmit}
                    aria-label="Mua combo ngay"
                    className={cn(
                        'w-full rounded-full bg-[var(--color-accent-orange)] py-3 text-base font-normal! text-white transition-opacity hover:opacity-80',
                        {
                            'cursor-not-allowed opacity-60': isLoading,
                        },
                    )}
                    loading={isLoading}
                    disabled={isLoading}>
                    Mua ngay deal sốc
                </Button>
            </div>
        </div>
    );
};

export default ProductComboSummary;
